import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Permission } from './types/permission.type';

/**
 * Fetches the list of permissions, both Datastream-scoped and global. The API returns both
 * scopes — clients renders what is returned without filtering (umbrella spec §Roles &
 * Permissions scoping).
 *
 * @param instance - Ky HTTP instance from the application store.
 * @returns OperationResultWithData wrapping `Permission[]`.
 */
export const getPermissions = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<Permission[]>>(Uri.permissions.base).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
